import React from 'react';
import {
  Button,
  Copy,
  Flex,
  Heading,
  Square,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { Modal } from 'src/components/Modal/Modal';

export type ConfirmPasswordRestrictionProps = {
  onConfirm: (value: boolean) => void;
  onClose: () => void;
};

export function ConfirmPasswordRestriction({
  onConfirm,
  onClose,
}: ConfirmPasswordRestrictionProps): JSX.Element {
  return (
    <Modal size="sm">
      <Square as="header" dimension="2" width="100%">
        <Square inset="md">
          <Heading variant="h1">
            Are you sure you want to restrict diners to SSO login only?
          </Heading>
        </Square>
      </Square>
      <Square inset="md">
        <Copy variant="body">
          Saving a client with SSO enabled and restricting that client to SSO
          login only is not a change that can be undone in the Corp Admin tool.
          If you need to change this setting, you will need to ask the
          engineering team to make that change
        </Copy>
      </Square>
      <Square as="footer" dimension="2" inset="md">
        <Flex>
          <Stack flex={1} x="x-sm" data-testid="add-button-wrapper">
            <Button
              variant="primary"
              buttonSize="medium"
              onClick={(): void => {
                onConfirm(true);
              }}
              block
            >
              Yes
            </Button>
          </Stack>
          <Stack flex={1}>
            <Button
              variant="secondary"
              buttonSize="medium"
              onClick={onClose}
              block
            >
              Cancel
            </Button>
          </Stack>
        </Flex>
      </Square>
    </Modal>
  );
}
